var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "priority-item queue-queued mt-3" }, [
    _c("div", { staticClass: "d-flex align-items-center gap-50" }, [
      _c("i", { staticClass: "fa fa-question lh-inherit" }),
      _vm._v(" "),
      _c("h2", [_vm._v(_vm._s(_vm._f("trans")("Info")))]),
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    " +
          _vm._s(
            _vm._f("trans")("Some results have been automatically removed.")
          ) +
          "\n  "
      ),
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    " +
          _vm._s(
            _vm._f("trans")("No Credits have been deducted for these results.")
          ) +
          "\n  "
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }